import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-context-button",
    styleUrls: ["./context-button.component.scss"],
    templateUrl: "./context-button.component.html"
})
export class FUIContextButtonComponent extends FUIButtonComponent {

}
